import $ from 'jquery'
import VueCookie from 'vue-cookie'
import jwtDecode from "jwt-decode";
import uuidv4 from "uuid/v4";

export const BAE_USER_TOKEN_COOKIE_NAME = 'BAEAU'
export const BAE_USER_KNOWN_COOKIE_NAME = 'BAE-KNOWN-USER'

/**
 * Determine device type
 * @param screenWidth
 * @return {boolean}
 */
export const isMobile = (screenWidth = window.screen.width) =>
  screenWidth <= 640

/**
 * Determine device type
 * @param screenWidth
 * @return {boolean}
 */
export const isDesktop = (screenWidth = window.screen.width) =>
  screenWidth > 640

/**
 * Combine passed objects
 * @return {*}
 */
export const extend = () => {
  for (let i = 1; i < arguments.length; i++) {
    for (let key in arguments[i]) {
      if (arguments[i].hasOwnProperty(key)) {
        arguments[0][key] = arguments[i][key]
      }
    }
  }
  return arguments[0]
}

/**
 * @param el
 * @param fn
 * @return {*}
 */
export const closest = (el, fn) => {
  while (el) {
    if (fn(el)) {
      return el
    }
    el = el.parentNode
  }
}

/**
 * Slugify passed value
 * Replace spaces with -
 * Remove all non-word chars
 * Replace multiple - with single
 * Trim - from start of text
 * Trim - from end of text
 * @param text
 * @return String
 */
export const slugify = text =>
  text
    .toString()
    .toLowerCase()
    .replace(/\s+/g, '-')
    .replace(/[^\w\-]+/g, '')
    .replace(/\-\-+/g, '-')
    .replace(/^-+/, '')
    .replace(/-+$/, '')

/**
 * This function loops into an array of objects, and tries to find if the object has a property
 * equal to the value provided
 *
 * @param myArray: the array of objects
 * @param propertyName: the name of the property to check
 * @param searchTerm: the value of the property to check
 * @returns {*} the index of the element in the array, false if it's not found
 */
export const arrayObjectIndexOf = (myArray, propertyName, searchTerm) => {
  for (let i = 0, len = myArray.length; i < len; i++) {
    let item = myArray[i][propertyName]

    // TODO: implement this using lodash or a handmade solution

    // Array comparison
    if (typeof item !== 'string') {
      if (JSON.stringify(item) === JSON.stringify(searchTerm)) {
        return { index: i, item: myArray[i] }
      }
    }

    // String comparison
    if (item === searchTerm) {
      return { index: i, item: myArray[i] }
    }
  }

  return false
}

/**
 * This function loops into an array of objects, and tries to find all the objects with a property
 * equal to the value provided
 *
 * @param myArray: the array of objects
 * @param propertyName: the name of the property to check
 * @param searchTerm: the value of the property to check
 * @returns [array] the indexes of the elements in the array, false if it's not found
 */

export const arrayObjectAllIndexes = (myArray, propertyName, searchTerm) => {
  let indexes = []
  for (let i = 0, ilen = myArray.length; i < ilen; i++) {
    if (myArray[i][propertyName] === searchTerm) {
      indexes.push(i)
    }
  }
  return indexes
}

/**
 * This function verifies if one object is empty (has no properties)
 *
 * @param anObject
 * @returns {boolean}
 */
export const isObjectEmpty = anObject => {
  for (var i in anObject) {
    return false
  }
  return true
}

/**
 * Determine if value is numeric
 * @param n
 * @return {boolean}
 */
export const isNumeric = n => !isNaN(parseFloat(n)) && isFinite(n)

/**
 * TODO: Make testable
 * @param key
 * @return {Array.<*>|*}
 */
export const getBrOption = function getBrOption(key) {
  let brPageOptions = window.brPageOptions || []
  let option = brPageOptions.filter(function(item) {
    return item && item[0] && item[0] === key
  })

  if (Array.isArray(option) && option.length === 1) {
    option = option[0][1]
  }

  if (Array.isArray(option) && option.length === 0) {
    option = null
  }

  return option
}

/**
 * @param name
 * @param url
 * @return {*}
 */
export const getParameterByName = (name, url = window.location.href) => {
  name = name.replace(/[\[\]]/g, '\\$&')
  let regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)')
  let results = regex.exec(url)

  if (!results) {
    return null
  }

  if (!results[2]) {
    return ''
  }

  return decodeURIComponent(results[2].replace(/\+/g, ' '))
}

/**
 * TODO: Might be duplicate code the above function seems to do extra actions
 * @param name
 * @param searchString
 * @return {string}
 */
export const getUrlParameter = (name, searchString = location.search) => {
  name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]')
  let regex = new RegExp('[\\?&]' + name + '=([^&#]*)')
  let results = regex.exec(searchString)
  return results === null
    ? ''
    : decodeURIComponent(results[1].replace(/\+/g, ' '))
}

/**
 * This function validates zip codes. Will return an object with location details if valid, will return an error
 * string if invalid
 * TODO: Make testable
 * @param zip
 */
export const isValidZip = zip => {
  let results
  $.ajax({
    url: 'https://api.zippopotam.us/us/' + zip,
    cache: false,
    async: false,
    dataType: 'json',
    type: 'GET',
    timeout: 1000,
    success: function(result) {
      results = result.places[0]
    },
    error: function(jqXHR) {
      if (jqXHR.status === 404) {
        results = 'Zip code invalid.'
      } else {
        results = { response: 'An unknown error has occurred' }
      }
    }
  })
  return results
}

/**
 * This function checks for `--has-error` class and sets
 * focus on the first input with the class
 * TODO: Make testable
 * @returns {boolean}
 */
export const isValidForm = () => {
  if (document.getElementsByClassName('--has-error').length === 0) {
    return true
  } else {
    document
      .getElementsByClassName('--has-error')[0]
      .getElementsByTagName('INPUT')[0]
      .focus()
    return false
  }
}

/**
 * This function scrolls the document up to the position passed into it.
 * @param scrollHeight
 * @param speed
 */
export const scrollToPosition = (scrollHeight, speed = 500) => {
  $('html, body').animate({ scrollTop: scrollHeight }, speed)
}

/**
 * Process pixel impression URL to replace timestamp variable and prevent cache
 */

export const processPixel = pixel => {
  let cacheKiller = new Date().getTime()

  if (pixel.indexOf('[timestamp]') > -1) {
    pixel = pixel.replace('[timestamp]', cacheKiller)
  } else {
    let separator =
      pixel.substr(-1) === '?' ? '' : pixel.indexOf('?') === -1 ? '?' : '&'
    pixel = pixel + separator + 'brck=' + cacheKiller
  }

  return pixel
}

/**
 * @param fn
 * @param context
 * @return {Function}
 */
export const once = function once(fn, context) {
  let result

  return function() {
    if (fn) {
      result = fn.apply(context || this, arguments)
      fn = null
    }

    return result
  }
}

/**
 * TODO: Rewrite to make testable
 * http://stackoverflow.com/questions/6238351/fastest-way-to-detect-external-urls
 */
export const isExternalRegexClosure = (function() {
  let domainRe = /https?:\/\/((?:[\w\d\-]+\.)+[\w\d]{2,})/i

  return function(url) {
    function domain(url) {
      let results = domainRe.exec(url)
      if (results && results.length) {
        return results[1]
      }
      return false
    }

    return domain(location.href) !== domain(url)
  }
})()

/**
 * TODO: Rewrite to make testable
 */
export const targetBlank = function() {
  'use strict'
  let elements = document.querySelectorAll('a[href]:not([href=""])')
  let elementCount = elements.length
  for (let e = 0; e < elementCount; ++e) {
    if (isExternalRegexClosure(elements[e].href)) {
      elements[e].setAttribute('target', '_blank')
    }
  }
}

/**
 * Remove spaces from value
 */
export const spacesFormat = text => text.toString().replace(/ /g, '')

/**
 * Gets a value of document cookie by name
 */
export const getCookieByName = name => {
  const regex = new RegExp(name + '=([^;]+)')
  const value = regex.exec(window.document.cookie)
  return value != null ? decodeURIComponent(value[1]) : null
}

/**
 * Checks whether a user is currently authenticated or not
 */
export const isAuthenticated = alternateCookie => {
  const cookieName = alternateCookie || BAE_USER_TOKEN_COOKIE_NAME
  return !!VueCookie.get(cookieName)
}

/**
 * Gets authed user's information
 */
export const getAuthenticatedUser = alternateTokenCookie => {
  const cookieTokenName = alternateTokenCookie || BAE_USER_TOKEN_COOKIE_NAME
  return isAuthenticated(cookieTokenName)
    ? VueCookie.get(cookieTokenName)
    : null
}

export const getCustomerId = () => {
  const bearerToken = getAuthenticatedUser()
  return bearerToken ? jwtDecode(bearerToken).customer_id : uuidv4()
}

export const generateUUID = () => {
  return Math.round(Math.random() * 10000000).toString() + new Date().getTime()
}

/**
 * Returns a string in a format appropriate for dataCollector
 * note -- this a  legacy function that we need to add back in as a few components are still using it.
 * Change this on of all the components on the next refactor.
 * @param str
 */
export const legacyFormatString = str => str.toString().replace(/ /g, '-')

export const fauxAnchor = () => {
  document.querySelector('body').addEventListener('click', event => {
    const target = event.target.closest('[data-faux-anchor]')

    if (target) {
      event.preventDefault()

      const anchor = target.querySelector('a:first-of-type')
      const href = anchor ? anchor.getAttribute('href') : null

      if (!href) {
        return
      }

      // Need to deal with recirculation tracking
      if (
        anchor.dataset.linktype &&
        anchor.dataset.linktype === 'recirculation'
      ) {
        let dataLayer = window.dataLayer || []

        dataLayer.push({
          dL_navHeading: anchor.dataset.navheading.toLowerCase().trim(),
          dL_clickURL: anchor.getAttribute('href'),
          dL_clickText: anchor
            .text()
            .toLowerCase()
            .trim(),
          event: 'e_navRecirculation'
        })
      }

      if (anchor.getAttribute('target')) {
        window.open(href)
      } else {
        window.location = href
      }
    }
  })
}

export default {
  arrayObjectAllIndexes,
  arrayObjectIndexOf,
  closest,
  extend,
  getBrOption,
  getParameterByName,
  getUrlParameter,
  isDesktop,
  isMobile,
  isNumeric,
  isObjectEmpty,
  isValidForm,
  isValidZip,
  once,
  processPixel,
  scrollToPosition,
  slugify,
  targetBlank,
  spacesFormat,
  getCookieByName,
  generateUUID,
  fauxAnchor,
  getCustomerId,
  isAuthenticated,
  getAuthenticatedUser,
  BAE_USER_TOKEN_COOKIE_NAME,
  dataCollectorFormat: legacyFormatString
}
